/**
 * This file provides commonly used constants.
 */
export const SORT_BY_ASC = "asc";
export const SORT_BY_DESC = "desc";
